import { Component } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { OnboardingService } from '../services/onboarding.service';
import { MigrationModeService } from '../services/migration-mode.service';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { OnInit } from '@angular/core';
import { TokenStorageService } from './token-storage.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  
  // These properties will hold the user input
  email: string = '';
  password: string = '';
  errorMessage: string = '';
  registerUrl: string = '';
  
  constructor(
    private authService: AuthService,
    private onboardingService: OnboardingService,
    private migrationModeService: MigrationModeService,
    private router: Router,
    private tokenStorage: TokenStorageService
  ) {
    // Set the registerUrl dynamically using environment.baseUrl
    this.registerUrl = `${environment.baseUrl}/#/register`;
  }

  async ngOnInit() {
    // Mobile-only: Drop-down (Beni Hatırla) polyfill'i.
    // Şifre boş bırakılır, sadece e-posta native kasadan yüklenir.
    if (Capacitor.isNativePlatform()) {
      try {
        const saved = await Preferences.get({ key: 'mobile_saved_email' });
        if (saved.value) {
          this.email = saved.value;
        }
      } catch (error) {
        console.warn('Failed to load saved email', error);
      }
    }
  }

  login(): void {
    this.authService.login(this.email, this.password).subscribe({
      next: async (response) => {
        // Mobile-only: Giriş başarılıysa e-postayı native kasada hatırla
        if (Capacitor.isNativePlatform()) {
          try {
            await Preferences.set({ key: 'mobile_saved_email', value: this.email });
          } catch (error) {
            console.warn('Failed to save email', error);
          }
        }

        // C29: süper kullanıcı oturumu tenant'sızdır — doğrudan profil seçiciye.
        if (response?.kind === 'picker') {
          this.router.navigate(['/profiles']);
          return;
        }

        // Başlangıç sayfası tek kuraldan gelir (landingUrlFor). Garson ve mutfak
        // oturumu: geçiş modu ve onboarding adımları onlara ait değil —
        // kullanıcı bilgisi yüklenince doğrudan kendi ekranına.
        const landing = this.tokenStorage.landingUrl();
        if (this.tokenStorage.isMarsOnly()) {
          this.authService.fetchUserDetails().subscribe({
            next: () => this.router.navigate([landing]),
            error: () => this.router.navigate([landing]),
          });
          return;
        }

        this.authService.fetchUserDetails().subscribe({
          next: (details) => {
            const userId = Number(details?.user_id ?? details?.userId ?? details?.id);
            this.migrationModeService.resolveModeForUser(userId).subscribe({
              next: (mode) => {
                if (mode === 'legacy') {
                  this.router.navigate([landing]);
                  return;
                }

                this.onboardingService.getStatus(true).subscribe({
                  next: (status) => {
                    if (status.onboarding_completed) {
                      this.router.navigate([landing]);
                      return;
                    }

                    const nextStep = this.onboardingService.getCurrentStep(status);
                    const targetRoute = this.onboardingService.getRouteForStep(nextStep);
                    this.router.navigate([targetRoute]);
                  },
                  error: () => this.router.navigate([landing])
                });
              },
              error: () => this.router.navigate([landing])
            });
          },
          error: () => this.errorMessage = 'Failed to fetch user details'
        });
      },
      error: (error) => {
        //console.error('Login failed', error);
        // Handle login error here, like showing an error message
        this.errorMessage = 'Invalid login credentials. Please try again.'; // Set the error message
      },
    });
  }
}
